import {
  Grid,
  Typography,
  CardHeader,
  Card,
  Button,
  Chip,
  Stack,
  Divider,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import {
  getArchivedTeamService,
  getTeamService,
  getUserService,
} from "../services/loginService";
import { archiveUser, restoreUser } from "../services/archiveUserService";
import { setUserData } from "../features/authSlice";
import InviteUser from "./inviteUser";
import EditUser from "./editUser";

const Users = () => {
  const dispatch = useDispatch();
  const [dialogOpen, toggleDialog] = useState(false);
  const [selectedUser, setSelectedUser] = useState();
  const [editDialogOpen, toggleEditDialog] = useState(false);
  const [team, setTeam] = useState([]);
  const [archivedTeam, setArchivedTeam] = useState([]);
  const admin = useSelector((state) => state.auth.value.admin);
  const currentEmail = useSelector((state) => state.auth.value.user?.email);

  const loadTeam = useCallback(async () => {
    const [activeTeam, archived] = await Promise.all([
      getTeamService(),
      admin ? getArchivedTeamService() : Promise.resolve([]),
    ]);
    setTeam(activeTeam || []);
    setArchivedTeam(archived || []);
  }, [admin]);

  useEffect(() => {
    async function getData() {
      const res = await getUserService();
      dispatch(setUserData(res));
      await loadTeam();
    }
    getData();
  }, [dispatch, loadTeam]);

  const handleArchive = async (t) => {
    const ok = await archiveUser(t.email);
    if (ok) {
      await loadTeam();
    }
  };

  const handleRestore = async (t) => {
    const ok = await restoreUser(t.email);
    if (ok) {
      await loadTeam();
    }
  };

  return (
    <Grid item xs={12} textAlign="center" m={3}>
      <Typography variant="h6" color="initial">
        Users
      </Typography>
      {team.map((t) => (
        <Card variant="outlined" sx={{ margin: 1, padding: 1 }} key={t.id}>
          <CardHeader title={t.name} />
          <Typography variant="h6" color="initial" mb={1}>
            {t.email}
          </Typography>
          {admin && (
            <Stack
              direction="row"
              spacing={1}
              justifyContent="center"
              flexWrap="wrap"
            >
              <Chip
                clickable
                label="Edit Permissions"
                color="primary"
                onClick={() => {
                  setSelectedUser(t);
                  toggleEditDialog(true);
                }}
              />
              {t.email !== currentEmail && (
                <Chip
                  clickable
                  variant="outlined"
                  label="Archive"
                  color="default"
                  onClick={() => handleArchive(t)}
                />
              )}
            </Stack>
          )}
        </Card>
      ))}
      <br />
      {admin && (
        <Button variant="contained" onClick={() => toggleDialog(true)}>
          Invite User
        </Button>
      )}

      {admin && archivedTeam.length > 0 && (
        <>
          <Divider sx={{ my: 3 }} />
          <Typography variant="h6" color="text.secondary" gutterBottom>
            Archived Users
          </Typography>
          <Typography variant="body2" color="text.secondary" mb={1}>
            Archived users are hidden and can't log in. Restore to bring them back.
          </Typography>
          {archivedTeam.map((t) => (
            <Card
              variant="outlined"
              sx={{ margin: 1, padding: 1, opacity: 0.7 }}
              key={t.id}
            >
              <CardHeader title={t.name || t.email} />
              <Typography variant="h6" color="initial" mb={1}>
                {t.email}
              </Typography>
              <Chip
                clickable
                label="Restore"
                color="success"
                onClick={() => handleRestore(t)}
              />
            </Card>
          ))}
        </>
      )}

      <InviteUser dialogOpen={dialogOpen} handleClose={toggleDialog} />
      <EditUser
        dialogOpen={editDialogOpen}
        user={selectedUser}
        handleClose={toggleEditDialog}
      />
    </Grid>
  );
};

export default Users;
